import { render, staticRenderFns } from "./ScheduleForm.vue?vue&type=template&id=56da359e&"
import script from "./ScheduleForm.vue?vue&type=script&lang=ts&"
export * from "./ScheduleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports